import { useQuery } from "@tanstack/react-query";
import assertNever from "assert-never";
import React from "react";
import { Page } from "../../activities/AppPage";
import { API } from "../../API";
import useInstaPay from "../../hooks/useInstaPay";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import ErrorScaffold from "../ErrorScaffold";
import LoadingScaffold from "../LoadingScaffold";
import SelectInstaPayVisitsScreen from "./SelectInstaPayVisitsScreen";

type Props = {
  api: API;
  weekNum: number;
  onClickGoBack: () => void;
  onRequestGoToMain: () => void;
  onRequestNavigate: (page: Page) => void;
};

const SelectInstaPayVisitsActivity = (props: Props) => {
  const payrollQuery = useQuery({
    queryKey: ["instapay", "overview"],
    queryFn: () => props.api.getPayrollOverview(),
    keepPreviousData: true,
  });

  const instaPay = useInstaPay({
    api: props.api,
    onRequestGoToMain: props.onRequestGoToMain,
    onRequestNavigate: props.onRequestNavigate,
  });

  switch (payrollQuery.status) {
    case "loading":
      return (
        <LoadingScaffold title={translate(STRINGS.INSTAPAY)} onClickGoBack={props.onClickGoBack} />
      );
    case "error":
      return (
        <ErrorScaffold
          title={translate(STRINGS.OOPS)}
          message={translate(STRINGS.SOMETHING_WENT_WRONG)}
          onClickGoBack={props.onClickGoBack}
        />
      );
    case "success":
      return (
        <SelectInstaPayVisitsScreen
          visits={payrollQuery.data.visits}
          bankInformation={payrollQuery.data.bankInformation}
          onClickContinue={instaPay.withdraw}
          onClickGoBack={props.onClickGoBack}
        />
      );
    default:
      assertNever(payrollQuery);
  }
};

export default SelectInstaPayVisitsActivity;
